import { FC } from "react";

import { useEventContext } from "Bands/contexts";
import { EventHelpBlock } from "Bands/pages/event/components";
import { Spacer } from "shared/layout";

import { PushCopyModal } from "./components/PushCopyModal";
import { EventBlocksContainer as EventBlocks } from "./containers";

export const EventPage: FC = () => {
  const { eventBlocks, fetchingEventBlocks, showPushCopyModal, setShowPushCopyModal } =
    useEventContext();

  return (
    <Spacer size="l">
      {showPushCopyModal && (
        <PushCopyModal
          showPushCopyModal={showPushCopyModal}
          setShowPushCopyModal={setShowPushCopyModal}
        />
      )}
      {!eventBlocks?.length && !fetchingEventBlocks && <EventHelpBlock />}
      <EventBlocks />
    </Spacer>
  );
};
